import { render, staticRenderFns } from "./Volunteertable.vue?vue&type=template&id=22c7a8b6"
import script from "./Volunteertable.vue?vue&type=script&lang=js"
export * from "./Volunteertable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports